import { Pipe, PipeTransform } from '@angular/core';

import { periodicidades } from '../periodicidade';

@Pipe({
    name: 'periodicidadeSigla'
})
export class PeriodicidadeSiglaPipe implements PipeTransform {
    transform(periodicidade: number): string {
        if (!periodicidade) {
            return '';
        }

        const index = periodicidades.findIndex(periodicidadeFilter => periodicidadeFilter.id === periodicidade);
        if (index > -1) {
            return periodicidades[index].sigla;
        }
        return '';
    }
}
